import React from "react";
import PageHero from "@/components/PageHero";
import PageMeta from "@/components/PageMeta";
import LeadForm from "@/components/LeadForm";
import { School, Trophy, Tent, GraduationCap, Search, Network } from "lucide-react";

const PROGRAMS = [
  { Icon: School,        title: "School Programs",          desc: "PE-integrated skate hockey programs in partner schools." },
  { Icon: Trophy,        title: "District Leagues",         desc: "Inter-school and inter-college district tournaments." },
  { Icon: Tent,          title: "Youth Camps",              desc: "Pre-season camps run by PSHL-certified coaches." },
  { Icon: GraduationCap, title: "Coaching Certifications",  desc: "Tiered PSHL coaching certification program." },
  { Icon: Search,        title: "Talent Identification",    desc: "Combine days, scouting trials and PSHL8 player rating." },
  { Icon: Network,       title: "Grassroots Tournaments",   desc: "City-circuit grassroots events feeding the pro pipeline." },
];

export default function Academies() {
  return (
    <div>
      <PageMeta
        title="Academies — Building the Future of Skate Hockey"
        description="A grassroots-to-pro pathway that turns school kids into PSHL8 franchise players."
        image="/api/og/academies/og-image.png"
      />
      <PageHero
        overline="Academy & Youth"
        title={<>Building the Future of <span className="text-pshl-electric">Skate Hockey.</span></>}
        subtitle="A grassroots-to-pro pathway that turns school kids into PSHL franchise players."
        bgImage="https://images.pexels.com/photos/8972133/pexels-photo-8972133.jpeg"
      />

      <section className="section pt-0">
        <div className="pshl-container grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {PROGRAMS.map(({ Icon, title, desc }, i) => (
            <div key={title} data-testid={`academy-block-${i}`} className="bg-pshl-surface border border-white/10 hover:border-pshl-electric transition-colors p-6">
              <div className="h-10 w-10 grid place-items-center bg-pshl-electric/15 border border-pshl-electric/40">
                <Icon className="h-5 w-5 text-pshl-electric" />
              </div>
              <div className="font-display text-xl text-white mt-4">{title}</div>
              <div className="text-sm text-white/65 mt-2 leading-relaxed">{desc}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="section bg-[#08090E]">
        <div className="pshl-container grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.32em] text-pshl-electric font-display mb-3">Academy Partnership</div>
            <h2 className="font-display text-4xl text-white tracking-tighter">Run a PSHL Academy.</h2>
            <p className="mt-4 text-white/75 leading-relaxed">Partner with PSHL to launch a certified academy in your city or school. Register below.</p>
          </div>
          <div className="lg:col-span-7"><LeadForm defaultInterest="academy" title="Academy Partnership Inquiry" /></div>
        </div>
      </section>
    </div>
  );
}
